import React from 'react';

const Badge = ({
  children,
  variant = 'default', // default, success, warning, danger, info, secondary, outline
  className = ''
}) => {
  const variants = {
    default: 'bg-gray-700 text-gray-200 border-gray-600',
    success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    warning: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
    danger: 'bg-red-500/10 text-red-400 border-red-500/20',
    info: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
    secondary: 'bg-gray-600 text-gray-300 border-gray-500',
    outline: 'bg-transparent text-orange-400 border-orange-500/30',
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
